import { useMemo } from "react";
import { CookiesProvider } from "react-cookie";
import Tasks from "./Tasks";
import { Provider } from "react-redux";

const TaskApp = (props) => {
  const store = useMemo(() => ReactOnRails.getStore("layoutStore"), []);
  return (
    <Provider store={store}>
      <CookiesProvider>
        <Tasks
          admin={props.admin}
          ids={props.ids}
          agent={props.agent}
          dueness={props.dueness}
          orderBy={props.orderBy}
          orderDirection={props.orderDirection}
        />
      </CookiesProvider>
    </Provider>
  );
};

export default TaskApp;
